import React                   from 'react'
import i18n from '../../../i18n';
import ReactHtmlParser from 'html-react-parser';

export default () => {
  return (
    <div className="col-sm-12 content-body empty-tags">
      <div className="icon vertical-center"></div>
      <div className="vertical-center">
        <p>
          {ReactHtmlParser(i18n.t('tag.empty_page_content'))}
        </p>
      </div>
    </div>
  )
}
